import React from 'react';

interface NodeExpanderProps {
  hasChildren: boolean;
  isExpanded: boolean;
  onToggle: () => void;
}

export const NodeExpander: React.FC<NodeExpanderProps> = ({
  hasChildren,
  isExpanded,
  onToggle,
}) => {
  if (!hasChildren) {
    return (
      <span
        style={{
          display: 'inline-block',
          width: '18px',
          height: '14px',
        }}
      />
    );
  }

  return (
    <span
      className='opener'
      style={{
        display: 'inline-block',
        width: '14px',
        height: '14px',
        margin: '0px 4px',
        verticalAlign: 'top',
        textAlign: 'center',
        cursor: 'pointer',
        userSelect: 'none',
      }}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      {isExpanded ? '−' : '+'}
    </span>
  );
};
